import React from 'react';

const TextAvatar = ({ text, bgClass, textClass, size, fontSize = '55px', image }) => {
  const avatarSize = size || "100px";

  return (
    <div
      className={`mx-auto d-flex justify-content-center align-items-center rounded-circle mb-3 ${image ? '' : `bg-${bgClass || 'primary'} text-${textClass || 'light'}`}`}
      style={{
        width: avatarSize,
        height: avatarSize,
        fontSize: fontSize,
        fontWeight: "bold",
        overflow: "hidden",
        backgroundColor: image ? 'transparent' : undefined
      }}
    >
      {image ? (
        <img
          src={image}
          alt="avatar"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover"
          }}
        />
      ) : (
        text
      )}
    </div>
  );
};

export default TextAvatar;
